<template>
<div class="airlineprofile">
  <div class="airlineprofile__header">
    <h1 v-if="isEdit" class="medium-title">Edit Profile</h1>
    <h1 v-else class="medium-title">Add New Profile</h1>
  </div>
  <div class="airlineprofile__body">
    <div class="airlineprofile__body__left">
      <div class="airlineprofile__body__left__container">
        <div class="airlineprofile__body__left__container__item">
          <adx-input :label="`Name`" :value.sync="model.name" 
            :error.sync="vuelidateOptions.name.error" :ref="vuelidateOptions.name.ref"/>
        </div>
        <div class="airlineprofile__body__left__container__item">
          <adx-input :label="`Number of Traffic`" :value.sync="model.numberOfTraffic" 
            :error.sync="vuelidateOptions.numberOfTraffic.error" :ref="vuelidateOptions.numberOfTraffic.ref"/>
          <adx-select-dropdown :label="`Traffic Per`" :options="trafficOptions" :value.sync="model.trafficPeriod" 
            :error.sync="vuelidateOptions.trafficPeriod.error" :ref="vuelidateOptions.trafficPeriod.ref"/>
        </div>
      </div>
      <div class="airlineprofile__body__left__container">
        <h1 class="subhead title">Demographic</h1>
        <div v-for="(demo, index) in model.demographics" :key="index" class="demographic-wrapper">
        <div class="airlineprofile__body__left__container__item">
          <adx-input :label="`Name`" :value.sync="demo.name" 
            :error.sync="vuelidateOptions.demographics.error[index].name" :ref="vuelidateOptions.demographics.ref.name"/>
        </div>
        <div class="airlineprofile__body__left__container__item" v-for="(tp, indexType) in demo.type" :key="indexType">
          <adx-input :label="`Title`"  :value.sync="tp.title" 
            :error.sync="vuelidateOptions.demographics.error[index].type[indexType].title" :ref="vuelidateOptions.demographics.ref.title" />
          <adx-input :label="`Value`" :value.sync="tp.value"
            :error.sync="vuelidateOptions.demographics.error[index].type[indexType].value" :ref="vuelidateOptions.demographics.ref.value" />
          <div class="icon-wrapper"> <i @click="deleteRoute(model.demographics, index)" class="icon-deleted color-grey"></i> </div>
        </div>
        <div class="line-wrapper">
          <hr class="line" />
        </div>
        <div class="addNewButton">
          <button @click="addValue(demo, index)" class="color-red">Add new</button>
        </div>
        </div>
      </div>
      <div class="airlineprofile__body__left__browse">
        <div class="browse" @click="addDemographic">
          <span class="title">Add More Demographic</span>
        </div>
      </div>
    </div>
    <div class="airlineprofile__body__right">
      <div class="airlineprofile__body__right__container">
        <h1 class="subhead title">Profile Status ( Optional )</h1>
        <adx-checkbox :label="`Public`" :value.sync="model.status"/>
      </div>
      <div class="button"><button class="btn-large primary" @click="saveProfile">Save</button></div>
    </div>
  </div>
</div>
</template>


<script>
import InputTag from "@/components/Form/InputTag";
import { required, minLength, maxLength, numeric, alphaNum, alpha, requiredIf } from 'vuelidate/lib/validators'
import { ACheckbox, AInput, ATextArea, ASelectDropdown, AListDropdown} from "ui-kit-v1"

import * as validationLib from "@/lib/validation/"
const { helpers, validate } = validationLib;
import types from '@/lib/types'
import { restEdge } from "@/api/edgeUrls"
import api from "@/api"

export default {
  name: 'adx-airline-media-form',
  components: {
    "adx-checkbox": ACheckbox,
    "adx-input": AInput,
    "adx-input-tag": InputTag,
    "adx-select-dropdown": ASelectDropdown,
    "adx-textarea": ATextArea,
    "adx-dropdown-list": AListDropdown,
  },
  props: {

  },
  data() {
    return {
      tagLimit: 100,
      daysOfWeek: types.days_of_week,
      isLoadingPage: false,
      openingHoursMonday:null,
      includeParam: {
        "include": {"profileDemographic": "profileSubDemographic"}
      },
      trafficOptions: [
        {
          id: 1,
          value: 'month',
          label: 'Month'
        }
      ],
      model: {
        name: null,
        numberOfTraffic: null,
        trafficPeriod: null,
        status: null,
        demographics: [
          {
            name: null,
            type: [
              {
                title: null,
                value: null
              }
            ],
          }
        ]
      },
      airport: {
        operatingHours: []
      },
      vuelidateOptions: {
        name: {
          error: null,
          ref: 'name'
        },
        numberOfTraffic: {
          error: null,
          ref: 'numberOfTraffic'
        },
        trafficPeriod: {
          error: null,
          ref: 'trafficPeriod'
        },
        demographics: {
          error: [
            {
              name: null,
              type: [
                {
                  title: null,
                  value: null
                }
              ],
            }
          ],
          ref: {
            name: 'name',
            title: 'title',
            value: 'value'
          },
        },
      },
    }
  },
  validations: {
    model: {
      name: { required, minLength: minLength(3), maxLength: maxLength(50) },
      numberOfTraffic: { required, numeric },
      trafficPeriod: { required },
      demographics: {
        $each: {
          name : { required, minLength: minLength(3), maxLength: maxLength(50)  },
          type: {
            $each: {
              title: { 
                requiredIf: requiredIf((obj) => obj.value != null)
              },
              value: {
                requiredIf: requiredIf((obj) => obj.title != null)
              }
            }
          }
          
        }
      }
    }
  },
  computed: {
    isEdit: function(){
      this.id = this.$route.params.id
      return this.$route.params.id
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.isLoadingPage = true
    if(this.isEdit){
      this.getProfile()
    } else {
      this.isLoadingPage = false
    }
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    addValue(demo, index){
      this.model.demographics[index].type.push({
        title: null,
        value: null
      })
      this.vuelidateOptions.demographics.error[index].type.push({
        title: null,
        value: null
      })
    },
    addDemographic(){
      this.model.demographics.push({
        name: null,
        type: [{
          title: null,
          value: null
        }]
      })
      this.vuelidateOptions.demographics.error.push({
        name: null,
        type: [{
          title: null,
          value: null
        }]
      })
    },
    async getProfile(){
       const {data, status} = await api.get(restEdge.adminAirlineGetProfile(this.id), { needToken: true, useRestEdge: true });

       if (status == 200) {
      
         this.model.name = data.title
         this.model.numberOfTraffic = data.traffic
         this.model.trafficPeriod = data.trafficPeriod
         this.model.status = data.isPublic
         
         let demographics = []
         let errors = []
         if (data.profileDemographic) { 
           data.profileDemographic.map(dmg => {
             let type = []
             let error_type = []

             dmg.profileSubDemographic.map(sub_dmg => {
               type.push({
                  id: sub_dmg.id,
                  title: sub_dmg.title,
                  value: sub_dmg.value
               })
               error_type.push({
                  title: null,
                  value: null
               })
             })

             let demographic = {
                name : dmg.name,
                id : dmg.id,
                type : type,
             }
             let error = {
               name: null,
               type: error_type
             }
             demographics.push(demographic)
             errors.push(error)
           })
         }

         this.model.demographics = demographics
         this.vuelidateOptions.demographics.error = errors
       }
    },
    async saveProfile(){
       this.$v.$touch()

       if (this.$v.$invalid) {
        const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v.model, this.vuelidateOptions, this.$refs)
        if (collection) {
          this.vuelidateOptions[key].error[collection.index][collection.collectionKey] = message
        } else {
          this.vuelidateOptions[key].error = message
        }
        if (element) {
          this.$nextTick(function() {
            element.scrollIntoView()
          })
        }
      } else {
        let demographics = []
        this.model.demographics.map(x => {
          demographics.push({
            id: x.id,
            name: x.name,
            profileSubDemographic: x.type 
          })

        })
        let form = {
          title: this.model.name,
          traffic: this.model.numberOfTraffic,
          trafficPeriod: this.model.trafficPeriod,
          isPublic: this.model.status,
          profileDemographic: demographics
        }

        if (this.isEdit) {
          const {data, status} = await api.patch(restEdge.adminAirlineEditProfile(this.id), form, {useRestEdge: true, needToken: true})
          this.afterSave(status)
        } else {
          const {data, status} = await api.post(restEdge.adminAirlineCreateProfile, form, {useRestEdge: true, needToken: true})
          this.afterSave(status)
        }
      }

    },
    afterSave(status) {
      if (status == 200) {
        this.showSuccessNotification('Profile successfully saved!')
      } else {
        this.showErrorNotification('Oops data can not be saved!')
      }
    },
    showErrorNotification(message){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: message,
        type: 'danger'
      });
    },
    showSuccessNotification(message){
      this.$notify({
        group: 'saved',
        title: 'Success',
        text: message,
        type: 'success'
      });
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>


<style lang='scss'>
.airlineprofile {
  .selectDropdown .select input {
    min-height: 63px;
  }
  .input input {
    min-height: 63px;
  }
  .vue-input-tag-wrapper .new-tag {
    margin-top: 0px;
  }

  .input-tag {
    max-height: 24px;
  }
}
 </style>